import { Button, ComboBox, LoadingIndicator } from '@components';
import { months } from '@utils';
import { PLANO_TAESA } from '@utils/plans';
import { getMonth, getYear } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import api from '../../../../common/services/api';
import './styles.css';

export const AnoMesReferencia = ({
  urlGetPDF,
  relatorio = 'Extrato',
  anoInicialDefault = 1997,
  mesInicialDefault = 11,
}) => {
  const dataAtual = new Date();
  const { matricula, plano } = useSelector((state) => state.user.data);
  const dadosPessoais = useSelector((state) => state.user.dadosPessoais);
  const { statusPlano } = dadosPessoais;
  const corteExtrato = useSelector(
    (state) => state.configs.dataCorte?.data?.corteExtrato
  );
  const DIB = useSelector((state) => state.plan.DIB?.data);
  const custom = useSelector((state) => state.configs.tema);
  const [isLoading, setIsLoading] = useState(false);
  const [anoSelecionado, setAnoSelecionado] = useState(corteExtrato[1]);
  const [mesSelecionado, setMesSelecionado] = useState(corteExtrato[0]);

  const [habilitarPDF, setHabilitarPDF] = useState(false);
  const [opcoesMeses, setOpcoesMeses] = useState(
    months.sort((a, b) => {
      return b.numero.localeCompare(a.numero);
    })
  );
  const isAssistido =
    statusPlano === 'Assistido' || statusPlano === 'Pensionista';

  const dataInicialSplit = !isAssistido
    ? (dadosPessoais.dataAdmissao ?? '').split('-')
    : DIB.split('/').reverse();

  let anoInicial =
    parseInt(dataInicialSplit[0], 10) < anoInicialDefault
      ? anoInicialDefault
      : parseInt(dataInicialSplit[0], 10);
  let mesInicial =
    parseInt(dataInicialSplit[0], 10) < anoInicialDefault
      ? mesInicialDefault
      : parseInt(dataInicialSplit[1], 10);

  const ANO_INSTITUICAO_TAESA = 2012;
  const MES_INSTITUICAO_TAESA = 3;
  const isTaesa = plano === PLANO_TAESA;

  if (
    isTaesa &&
    (anoInicial < ANO_INSTITUICAO_TAESA ||
      (anoInicial === ANO_INSTITUICAO_TAESA &&
        mesInicial < MES_INSTITUICAO_TAESA))
  ) {
    anoInicial = ANO_INSTITUICAO_TAESA;
    mesInicial = MES_INSTITUICAO_TAESA;
  }

  const opcoesAnos = () => {
    const anos = [];
    let end = getYear(dataAtual) + 1;
    if (getMonth(dataAtual) === 0) end = getYear(dataAtual);
    for (let i = anoInicial; i < end; i += 1) {
      if (!(i === anoInicial && mesInicial === 12) && i <= corteExtrato[1]) {
        anos.push(i.toString());
      }
    }
    return anos.sort((a, b) => {
      return b.localeCompare(a);
    });
  };

  const ordenarMesesDesc = (meses) => {
    return meses.sort((a, b) => b.numero - a.numero);
  };

  const filtrarMeses = () => {
    let mesesFiltrados = [];

    const anoSel = parseInt(anoSelecionado, 10);
    const anoLimite = parseInt(corteExtrato[1], 10);
    const mesLimite = parseInt(corteExtrato[0], 10);

    if (anoInicial === anoLimite) {
      mesesFiltrados = months.filter(
        (mes) => mes.numero > mesInicial && mes.numero <= mesLimite
      );
    } else if (anoSel === anoLimite) {
      mesesFiltrados = months.filter((mes) => mes.numero <= mesLimite);
    } else if (anoSel === anoInicial) {
      mesesFiltrados = months.filter((mes) => mes.numero > mesInicial);
    } else {
      mesesFiltrados = [...months];
    }

    return ordenarMesesDesc(mesesFiltrados);
  };

  const retiramesInicialExtrato = () => {
    if (anoSelecionado === anoInicial) {
      const mesesFiltrados = opcoesMeses.filter(
        (mes) => mes.numero <= mesInicial
      );
      setOpcoesMeses(mesesFiltrados);
    }
  };

  useEffect(() => {
    if (mesSelecionado !== '' && anoSelecionado !== '') {
      setHabilitarPDF(true);
    }

    const meses = filtrarMeses();
    if (meses.length > 0) {
      setOpcoesMeses(meses);
    }

    if (parseInt(anoSelecionado, 10) === anoInicial) {
      retiramesInicialExtrato();
    }
  }, [anoSelecionado, mesSelecionado]);

  async function baixarArquivoPDF() {
    setIsLoading(true);

    try {
      await api
        .get(urlGetPDF + anoSelecionado + mesSelecionado, {
          responseType: 'arraybuffer',
        })
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${relatorio} participante - ${matricula}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      toast.error(`Erro ao gerar ${relatorio}`);
    }
  }

  return (
    <div className="card">
      <div className="card-body">
        <h2>
          <strong>{relatorio}</strong>
        </h2>
        <div className="row col-12 col-md-8 col-lg-6 mb-4 mt-4">
          {!isLoading ? (
            <>
              <ComboBox
                color={custom.nomeCorPrincipal}
                label="Ano"
                className="mt-3 col-12 col-md4 col-lg-6"
                value={anoSelecionado}
                onChange={setAnoSelecionado}
                tooltip="Selecione o ano de referência"
                options={opcoesAnos().map((x) => {
                  return { value: x, label: x };
                })}
              />
              <ComboBox
                color={custom.nomeCorPrincipal}
                label="Mês"
                className="mt-3 col-12 col-md4 col-lg-6"
                value={mesSelecionado}
                onChange={setMesSelecionado}
                tooltip="Escolha o mês de referência"
                options={opcoesMeses.map((s) => {
                  return {
                    value: s.numero,
                    label: s.nome,
                  };
                })}
              />

              <Button
                onClick={() => baixarArquivoPDF()}
                className="ts-14 mb-2 col-6 mt-4"
                disabled={!habilitarPDF}
              >
                Baixar
              </Button>
            </>
          ) : (
            <LoadingIndicator />
          )}
        </div>
      </div>
    </div>
  );
};
